import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntTableColumnsLimiterComponent} from "./int-table-columns-limiter.component";
import {
  IntBadgeModule,
  IntButtonModule,
  IntDefaultCheckboxModule,
  IntEmptyDividerModule,
  IntTargetDropdownModule
} from "../../components";
import {ReactiveFormsModule} from "@angular/forms";
import {IntTableColumnsLimiterItemDirective} from "./int-table-columns-limiter-item.directive";
import {IntTableColumnsLimiterDropdownComponent} from "./int-table-columns-limiter-dropdown.component";

@NgModule({
  imports: [
    CommonModule,
    IntTargetDropdownModule,
    IntDefaultCheckboxModule,
    ReactiveFormsModule,
    IntEmptyDividerModule,
    IntButtonModule,
    IntBadgeModule
  ],
  declarations: [
    IntTableColumnsLimiterComponent,
    IntTableColumnsLimiterItemDirective,
    IntTableColumnsLimiterDropdownComponent
  ],
  exports: [
    IntTableColumnsLimiterComponent,
    IntTableColumnsLimiterItemDirective,
    IntTableColumnsLimiterDropdownComponent
  ]
})
export class IntTableColumnsLimiterModule {}
